/**
 * Shared copy for the Investment Rebalancing control, used by both the wizard
 * Strategy step and the results-page panel so the tax caveat can't drift between
 * the two surfaces (#1623 uk-tax review).
 */

export const REBALANCING_CGT_CAVEAT =
  'Switching funds within a SIPP or ISA is tax-free; adjusting a taxable (GIA) account is a disposal that may trigger Capital Gains Tax.';

export const FIXED_ALLOCATION_BLEND_NOTE =
  'Applies one equity/bond split across your wrappers — and both people in a joint plan — not individual fund switches.';
